import { render, staticRenderFns } from "./graduationForm.vue?vue&type=template&id=df874cbc&scoped=true&"
import script from "./graduationForm.vue?vue&type=script&lang=js&"
export * from "./graduationForm.vue?vue&type=script&lang=js&"
import style0 from "./graduationForm.vue?vue&type=style&index=0&id=df874cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df874cbc",
  null
  
)

export default component.exports